import { t as e } from "./rolldown-runtime-Dy4uBu1J.js";
import { n as t, t as n } from "./createEndpoints-BYEC3FIA.js";
import { i as r, o as i, t as a } from "./sanitiseRequestBody-Dm5hzjxP.js";
import { t as o } from "./createQueryParams-D2aMgLX5.js";
import { t as s } from "./creditNotes.cacheKeys-CnS0uUPf.js";
//#region src/clients/dashboard/v20240509/endpoints/integrations/integrations.cacheKeys.ts
var c = "integrations", l = "integrationAppToken", u = "integrationOAuthRedirect", d = t({
	queryKey: [c],
	route: () => "/integrations",
	mocking: {
		match: /\/api\/integrations/,
		mock: { items: [] }
	}
}), f = "listPrices", p = "prices", m = t({
	route: (e) => `/list-prices/${e.id}`,
	queryKey: [f],
	mocking: {
		match: /\/api\/list-prices\/(.+)/,
		mock: {
			id: "price-1",
			name: "Example One Time Price",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "10.00"
			},
			currency: "USD",
			createdAt: "2024-06-11",
			integrationIds: [{
				service: "Xero",
				id: "foo"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ARREARS",
			customMetricParameters: []
		}
	}
}), ee = t({
	route: (e) => `/list-prices${o(e)}`,
	queryKey: [f],
	mocking: {
		match: /\/api\/list-prices(\?(.*))?$/,
		mock: {
			items: [{
				id: "price-1",
				name: "Example One Time Price",
				productId: "product-1",
				structure: {
					pricingType: "ONE_TIME",
					price: "10.00"
				},
				currency: "USD",
				createdAt: "2024-06-11",
				integrationIds: [{
					service: "Xero",
					id: "foo"
				}],
				billingFrequency: "ONE_TIME",
				billingType: "IN_ARREARS",
				customMetricParameters: []
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), h = t({
	route: (e) => `/prices/${e.id}`,
	queryKey: [p],
	mocking: {
		match: /\/api\/prices\/(.+)/,
		mock: {
			id: "price-1",
			name: "Example One Time Price",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "10.00"
			},
			currency: "USD",
			createdAt: "2024-06-11",
			integrationIds: [{
				service: "Xero",
				id: "foo"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ARREARS",
			customMetricParameters: []
		}
	}
}), g = t({
	route: (e) => `/prices${o(e)}`,
	queryKey: [p],
	mocking: {
		match: /\/api\/prices(\?(.*))?$/,
		mock: {
			items: [{
				id: "price-1",
				name: "Example One Time Price",
				productId: "product-1",
				structure: {
					pricingType: "ONE_TIME",
					price: "10.00"
				},
				currency: "USD",
				createdAt: "2024-06-11",
				integrationIds: [{
					service: "Xero",
					id: "foo"
				}],
				billingFrequency: "ONE_TIME",
				billingType: "IN_ARREARS",
				customMetricParameters: []
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), _ = "products", v = "productMetadata", y = t({
	route: (e) => `/products${o(e)}`,
	queryKey: [_],
	mocking: {
		match: /\/api\/products(\?(.*))?$/,
		mock: {
			items: [{
				id: "product-1",
				name: "Example Product",
				label: "example-product",
				createdAt: "2024-06-11",
				updatedAt: "2024-06-11"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), b = t({
	route: ({ id: e }) => `/products/${e}`,
	queryKey: [_],
	mocking: {
		match: /\/api\/products\/(.+)/,
		mock: {
			id: "product-1",
			name: "Example Product",
			label: "example-product",
			createdAt: "2024-06-11",
			updatedAt: "2024-06-11"
		}
	}
}), x = t({
	route: ({ id: e }) => `/products/${e}/metadata`,
	queryKey: [v],
	mocking: {
		match: /\/api\/products\/(.+)\/metadata$/,
		mock: { priceVariants: [{
			id: "1",
			name: "Demo Product",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "150.00"
			},
			currency: "GBP",
			integrationIds: [{
				service: "Stripe",
				id: "1"
			}],
			billingFrequency: "MONTHLY",
			billingType: "IN_ARREARS",
			customMetricParameters: [],
			createdAt: "2021-01-01T00:00:00Z",
			listPriceId: "1"
		}, {
			id: "2",
			name: "Demo Product",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "1.00"
			},
			currency: "GBP",
			integrationIds: [{
				service: "Xero",
				id: "123"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ADVANCE",
			customMetricParameters: [],
			createdAt: "2021-01-01T00:00:00Z",
			listPriceId: "2"
		}] }
	}
}), S = t({
	route: () => "/sequence-account-settings",
	queryKey: ["sequenceAccountSettings"],
	mocking: {
		match: /\/api\/sequence-account-settings/,
		mock: {
			id: "settings-1",
			sequenceAccountId: "sequence-account-1",
			enabledCurrencies: ["USD", "EUR"]
		}
	}
}), C = "taxRates", w = t({
	route: ({ id: e }) => `/tax-rates/${e}`,
	queryKey: [C],
	mocking: {
		match: /\/api\/tax-rates\/(.+)/,
		mock: {
			id: "tax-rate-1",
			name: "string",
			invoiceName: "string",
			invoiceShortName: "string",
			description: "string",
			amount: "0.2",
			country: "GB",
			isArchived: !1
		}
	}
}), T = t({
	route: (e) => `/tax-rates${o(e)}`,
	queryKey: [C],
	mocking: {
		match: /\/api\/tax-rates(\?(.*))?$/,
		mock: {
			items: [{
				id: "string",
				name: "string",
				invoiceName: "string",
				invoiceShortName: "string",
				description: "string",
				amount: "0.2",
				country: "GB",
				isArchived: !1
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), E = n({
	route: () => "/prices",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [[p], [v]],
	mocking: {
		match: /\/api\/prices$/,
		mock: {
			id: "price-1",
			name: "Example One Time Price",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "10.00"
			},
			currency: "USD",
			createdAt: "2024-06-11",
			integrationIds: [{
				service: "Xero",
				id: "foo"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ARREARS",
			customMetricParameters: []
		}
	}
}), D = n({
	route: () => "/products",
	method: "POST",
	body: ({ body: e }) => JSON.stringify({
		name: e.name,
		...e.label ? { label: e.label } : {}
	}),
	invalidateQueries: [_],
	mocking: {
		match: /\/api\/products$/,
		mock: {
			id: "product-1",
			name: "Example Product",
			label: "example-product",
			createdAt: "2024-06-11",
			updatedAt: "2024-06-11"
		}
	}
}), O = n({
	route: ({ id: e }) => `/credit-notes/${e}/line-items/from-invoice`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	config: { responseTransform: () => Promise.resolve(void 0) },
	invalidateQueries: [s],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-items\/from-invoice$/,
		mock: void 0
	}
}), k = t({
	route: (e) => `/usage-events/distinct-aliases-count${o(e.filters)}`,
	queryKey: ["distinctCustomerAliasCount"],
	mocking: {
		match: /\/api\/usage-events\/distinct-aliases-count(\?(.*))?$/,
		mock: { distinctAliasCount: "10" }
	}
}), A = n({
	route: (e) => `/integrations/${e.service}`,
	method: "POST",
	body: () => JSON.stringify({}),
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/integrations\/(.+)$/,
		mock: {
			service: "Xero",
			state: "CONNECTED",
			enabled: !0,
			authFailure: !1,
			defaultLedgerAccounts: {
				chargeAccount: "200",
				creditAccount: "810",
				minimumAccount: "123",
				taxLiabilityAccount: "820"
			},
			defaultTaxCodes: { untaxedCustomerTaxCode: "NONE" },
			type: "Accounting",
			syncedEntityTypes: ["CUSTOMER", "INVOICE"]
		}
	}
}), j = n({
	route: ({ service: e }) => `/integrations/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/integrations\/(.+)$/,
		mock: {
			service: "Xero",
			state: "CONNECTED",
			enabled: !0,
			authFailure: !1,
			defaultLedgerAccounts: {
				chargeAccount: "200",
				creditAccount: "810",
				minimumAccount: "123",
				taxLiabilityAccount: "820"
			},
			defaultTaxCodes: { untaxedCustomerTaxCode: "NONE" },
			type: "Accounting",
			syncedEntityTypes: ["CUSTOMER", "INVOICE"]
		}
	}
}), M = n({
	route: ({ service: e }) => `/integrations/${e}`,
	method: "DELETE",
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/integrations\/(.+)$/,
		mock: void 0
	}
}), N = n({
	route: ({ service: e }) => `/integrations/${e}/links`,
	method: "DELETE",
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/integrations\/(.+)\/links$/,
		mock: void 0
	}
}), P = n({
	route: ({ service: e }) => `/integrations/${e}/authorize/redirect`,
	method: "POST",
	invalidateQueries: [u],
	mocking: {
		match: /\/api\/integrations\/(.+)\/authorize\/redirect$/,
		mock: { url: "http://localhost:3000" }
	}
}), te = n({
	route: ({ service: e, code: t, state: n }) => `/integrations/${e}/authorize/complete?code=${encodeURIComponent(t)}&state=${encodeURIComponent(n)}`,
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/integrations\/(.+)\/authorize\/complete/,
		mock: { success: !0 }
	}
}), F = n({
	route: () => "/list-prices",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [f],
	mocking: {
		match: /\/api\/list-prices$/,
		mock: {
			id: "price-1",
			name: "Example One Time Price",
			productId: "product-1",
			structure: {
				pricingType: "ONE_TIME",
				price: "10.00"
			},
			currency: "USD",
			createdAt: "2024-06-11",
			integrationIds: [{
				service: "Xero",
				id: "foo"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ARREARS",
			customMetricParameters: []
		}
	}
}), I = {
	id: "list-price-1",
	name: "Example One Time Price",
	productId: "product-1",
	structure: {
		pricingType: "ONE_TIME",
		price: "10.00"
	},
	currency: "USD",
	createdAt: "2024-06-11",
	integrationIds: [{
		service: "Xero",
		id: "foo"
	}],
	billingFrequency: "ONE_TIME",
	billingType: "IN_ARREARS",
	customMetricParameters: []
}, L = n({
	route: ({ id: e }) => `/list-prices/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [f],
	mocking: {
		match: /\/api\/list-prices\/(.+)$/,
		mock: I
	}
}), R = n({
	route: ({ id: e }) => `/list-prices/${e}/archive`,
	method: "PUT",
	invalidateQueries: [f],
	mocking: {
		match: /\/api\/list-prices\/(.+)\/archive$/,
		mock: I
	}
}), z = "quoteSettings", B = t({
	route: ({ id: e }) => `/quotes/${e}/download`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: ["quotePdf"],
	mocking: {
		match: /\/api\/quotes\/(.+)\/download/,
		mock: new Blob([""], { type: "application/pdf" })
	}
}), V = t({
	route: () => "/integrations/token",
	queryKey: [l],
	mocking: {
		match: /\/api\/integrations\/token/,
		mock: { token: "integration.app token" }
	}
}), H = t({
	route: ({ id: e }) => `/users/${e}`,
	queryKey: ["SEQUENCE_USER"],
	mocking: {
		match: /\/api\/users\/(.+)/,
		mock: {
			id: "user-1",
			email: "foo@bar.com",
			sequenceAccountIds: ["account-1"],
			state: "active"
		}
	}
}), U = t({
	route: () => "/quotes/settings",
	queryKey: [z],
	mocking: {
		match: /\/api\/quotes\/settings/,
		mock: {
			isSignaturesEnabled: !0,
			customerPortalAuthRequired: "NOT_REQUIRED",
			createdAt: "2024-06-21T00:00:00.000Z",
			updatedAt: "2024-06-21T00:00:00.000Z",
			counterSigners: [{
				id: "counter-signer-1",
				name: "Counter Signer",
				email: "foo@bar.com"
			}],
			isAutoExecuteQuotesEnabled: !0,
			notifyCounterSignerLast: !0
		}
	}
}), W = n({
	route: () => "/quotes/settings",
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/quotes\/settings/,
		mock: {
			isSignaturesEnabled: !0,
			customerPortalAuthRequired: "NOT_REQUIRED",
			createdAt: "2024-06-21T00:00:00.000Z",
			updatedAt: "2024-06-21T00:00:00.000Z",
			counterSigners: [{
				id: "counter-signer-1",
				name: "Counter Signer",
				email: "foo@bar.com"
			}],
			isAutoExecuteQuotesEnabled: !0,
			notifyCounterSignerLast: !0
		}
	}
}), G = "invoices", K = "invoiceAccountingDateSettings", q = t({
	route: () => "/invoice-accounting-date-settings-for-sequence-account",
	queryKey: [K],
	mocking: {
		match: /\/api\/invoice-accounting-date-settings-for-sequence-account/,
		mock: {
			id: "settings-1",
			preference: "END_OF_BILLING_PERIOD",
			invoiceDueDateCalculatedFrom: "ACCOUNTING_DATE"
		}
	}
}), J = n({
	route: ({ id: e }) => `/invoice-accounting-date-settings/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/invoice-accounting-date-settings\/(.+)$/,
		mock: {
			id: "settings-1",
			preference: "INTENDED_INVOICE_CREATION_DATE",
			invoiceDueDateCalculatedFrom: "ACCOUNTING_DATE"
		}
	}
}), Y = t({
	route: (e) => `/usage-metrics${o(e)}`,
	queryKey: ["usageMetrics"],
	mocking: {
		match: /\/api\/usage-metrics(\?(.*))?$/,
		mock: {
			items: [{
				id: "metric-1",
				sequenceAccountId: "account-1",
				name: "Example Metric",
				description: "Example Description",
				metricType: "SIMPLE",
				eventType: "Example Event",
				aggregationType: "SUM",
				unit: "Example Unit",
				propertyFilters: {},
				propertiesToNegate: [],
				parameters: [{
					id: "parameter-1",
					usageMetricId: "metric-1",
					name: "Example Parameter",
					type: "INTEGER",
					description: "Example Description",
					defaultValue: "0"
				}]
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), X = t({
	route: (e) => `/invoices${o(e)}`,
	queryKey: [G],
	mocking: {
		match: /\/api\/invoices(\?(.*))?$/,
		mock: {
			items: [{
				id: "12345",
				sequenceAccountId: "seq-1234",
				status: "DRAFT",
				currency: "GBP",
				netTotal: "1000",
				grossTotal: "1000",
				totalTax: "0",
				customerId: "cust-1234",
				customerEmails: ["foo@bar.com"],
				customerLegalCompanyName: "Test Co.",
				customerBillingAddress: {
					line1: "123 Fake St",
					town: "London",
					postcode: "SW1A 1AA",
					country: "GB"
				},
				customerShippingAddress: {
					line1: "123 Fake St",
					town: "London",
					postcode: "SW1A 1AA",
					country: "GB"
				},
				isCustomerArchived: !1,
				metadata: [{
					key: "string",
					value: "string"
				}],
				paymentStatus: "PAID",
				createdAt: "2024-01-05",
				creditNoteIds: [],
				linkedServices: [{
					externalId: "string",
					externalService: "Xero",
					syncTime: "2024-01-05T12:00:00Z"
				}],
				accountingDate: "2024-02-01",
				customerTaxStatus: "TAX_EXEMPT",
				renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" }
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Z = n({
	route: ({ id: e }) => `/customer-aliases/${e}`,
	method: "DELETE",
	invalidateQueries: [r],
	mocking: {
		match: /\/api\/customer-aliases\/(.+)$/,
		mock: {
			id: "mock-alias-1",
			value: ""
		}
	}
}), Q = "customers", $ = "customerContacts", ne = t({
	route: ({ id: e }) => `/customers/${e}/aliases`,
	method: "GET",
	queryKey: ["customerAliases"],
	mocking: {
		match: /\/api\/customers\/(.+)\/aliases$/,
		mock: { items: [{
			id: "alias-id",
			value: "alias-value"
		}] }
	}
}), re = t({
	route: ({ customerId: e }) => `/customers/${e}/contacts`,
	method: "GET",
	queryKey: [$],
	mocking: {
		match: /\/api\/customers\/(.+)\/contacts$/,
		mock: { items: [
			{
				id: "contact-1",
				name: "Contact 1",
				email: "contact1@foo.com",
				purposes: ["BILLING"],
				notificationSubscriptions: ["BILLING"],
				createdAt: "2024-06-24T00:00:00.000Z",
				updatedAt: "2024-06-24T00:00:00.000Z"
			},
			{
				id: "contact-2",
				email: "contact2@foo.com",
				name: "Contact 2",
				purposes: [],
				notificationSubscriptions: ["BILLING"],
				createdAt: "2024-06-24T00:00:00.000Z",
				updatedAt: "2024-06-24T00:00:00.000Z"
			},
			{
				id: "contact-3",
				email: "contact3@foo.com",
				name: "Contact 3",
				purposes: [],
				notificationSubscriptions: [],
				createdAt: "2024-06-24T00:00:00.000Z",
				updatedAt: "2024-06-24T00:00:00.000Z"
			}
		] }
	}
}), ie = n({
	route: ({ customerId: e }) => `/customers/${e}/contacts`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(a(e, ["email", "name"])),
	invalidateQueries: [$, Q],
	mocking: {
		match: /\/api\/customers\/(.+)\/contacts$/,
		mock: {
			name: "Contact 1",
			email: "contact1@foo.com",
			purposes: [],
			notificationSubscriptions: ["BILLING"],
			id: "contact-1",
			createdAt: "2024-06-24T00:00:00.000Z",
			updatedAt: "2024-06-24T00:00:00.000Z"
		}
	}
}), ae = n({
	route: ({ customerId: e, contactId: t }) => `/customers/${e}/contacts/${t}/archive`,
	method: "POST",
	invalidateQueries: [$],
	mocking: {
		match: /\/api\/customers\/(.+)\/contacts\/(.+)\/archive$/,
		mock: {
			id: "contact-1",
			email: "contact1@foo.com",
			name: "Contact 1",
			purposes: [],
			notificationSubscriptions: ["BILLING"],
			createdAt: "2024-06-24T00:00:00.000Z",
			updatedAt: "2024-06-24T00:00:00.000Z",
			archivedAt: "2024-06-25T00:00:00.000Z"
		}
	}
}), oe = n({
	route: ({ customerId: e, contactId: t }) => `/customers/${e}/contacts/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(a(e, ["email", "name"])),
	invalidateQueries: [$],
	mocking: {
		match: /\/api\/customers\/(.+)\/contacts\/(.+)$/,
		mock: {
			id: "contact-1",
			email: "contact1@foo.com",
			name: "Contact 1",
			purposes: [],
			notificationSubscriptions: ["BILLING"],
			createdAt: "2024-06-24T00:00:00.000Z",
			updatedAt: "2024-06-24T00:00:00.000Z",
			archivedAt: "2024-06-25T00:00:00.000Z"
		}
	}
}), se = i({
	endpoints: {
		getDistinctCustomerAliasCountForUsageEvents: k,
		getIntegrations: d,
		getInvoiceAccountingDateSettings: q,
		getInvoices: X,
		getListPrice: m,
		getListPrices: ee,
		getProduct: b,
		getProducts: y,
		getProductMetadata: x,
		getPrice: h,
		getPrices: g,
		getSequenceAccountSettings: S,
		getTaxRate: w,
		getTaxRates: T,
		getUsageMetrics: Y,
		postCreditNoteLineItems: O,
		postListPrice: F,
		postPrice: E,
		postProduct: D,
		putInvoiceAccountingDateSettings: J,
		putListPrice: L,
		putListPriceArchive: R,
		postIntegration: A,
		putIntegration: j,
		deleteIntegration: M,
		deleteIntegrationLinks: N,
		postIntegrationAuthRedirect: P,
		postAuthorizeComplete: te,
		downloadQuotePdf: B,
		getIntegrationAppToken: V,
		getUser: H,
		getQuoteSettings: U,
		putQuoteSettings: W,
		.../* @__PURE__ */ e({
			deleteCustomerAlias: () => Z,
			getCustomerAliases: () => ne,
			getCustomerContacts: () => re,
			postCustomerContact: () => ie,
			postCustomerContactArchive: () => ae,
			putCustomerContact: () => oe
		})
	},
	version: "2024-05-09"
});
//#endregion
export { se as t };

//# sourceMappingURL=v20240509-JTkMfURM.js.map